import PlanCard from "@components/PlanCard"
import SubscriptionForm from "@components/SubscriptionForm"
import { useTranslation } from "react-i18next"
import { Plan, StripePrice } from "src/types"

interface Props {
  currency: string
  isSubmitting: boolean
  setIsSubmitting: (isSubmitting: boolean) => void
  endTime: number
  weeklyIntroPrice: StripePrice | undefined
  weeklyPrice: StripePrice | undefined
  monthlyIntroPrice: StripePrice | undefined
  monthlyPrice: StripePrice | undefined
  yearlyIntroPrice: StripePrice | undefined
  yearlyPrice: StripePrice | undefined
  selectedPlan: Plan
  onPlanChange: (plan: Plan) => void
}

export default function Plans({
  currency,
  isSubmitting,
  setIsSubmitting,
  endTime,
  weeklyIntroPrice,
  weeklyPrice,
  monthlyIntroPrice,
  monthlyPrice,
  yearlyIntroPrice,
  yearlyPrice,
  selectedPlan,
  onPlanChange,
}: Props) {
  const { t } = useTranslation()

  const getSelectedPriceId = () => {
    switch (selectedPlan) {
      case "weekly":
        return weeklyIntroPrice?.id
      case "monthly":
        return monthlyIntroPrice?.id
      case "yearly":
        return yearlyIntroPrice?.id
    }
  }

  const getSelectedFullPrice = () => {
    switch (selectedPlan) {
      case "weekly":
        return weeklyPrice
      case "monthly":
        return monthlyPrice
      case "yearly":
        return yearlyPrice
    }
  }

  return (
    <div className="space-y-4 sm:space-y-6">
      <PlanCard
        bestOffer={true}
        currency={currency}
        isSubmitting={isSubmitting}
        periodAmount={1}
        periodUnit="year"
        plan="yearly"
        setIsSubmitting={setIsSubmitting}
        stripeIntroPrice={yearlyIntroPrice}
        stripePrice={yearlyPrice}
        endTime={endTime}
        isSelected={selectedPlan === "yearly"}
        onSelect={() => onPlanChange("yearly")}
      />

      <PlanCard
        currency={currency}
        isSubmitting={isSubmitting}
        periodAmount={1}
        periodUnit="month"
        plan="monthly"
        setIsSubmitting={setIsSubmitting}
        stripeIntroPrice={monthlyIntroPrice}
        stripePrice={monthlyPrice}
        endTime={endTime}
        isSelected={selectedPlan === "monthly"}
        onSelect={() => onPlanChange("monthly")}
      />

      <div className="space-y-3">
        <SubscriptionForm
          buttonClassName="custom-button-primary uppercase"
          buttonTitle={t("pages.checkout.plans.continue")}
          currency={currency}
          fullPrice={getSelectedFullPrice()}
          isSubmitting={isSubmitting}
          plan={selectedPlan}
          priceId={getSelectedPriceId()}
          setIsSubmitting={setIsSubmitting}
        />

        <p className="text-center text-sm">
          {t("pages.checkout.plans.cancelAnytime")}
        </p>

        <p className="text-center text-sm font-bold">
          {t("pages.checkout.plans.moneyBackGuarantee")}
        </p>
      </div>
    </div>
  )
}
